<template>
  <div class='InputReg' :style="cont">
    <div class="label" :style="label">
      {{ text }}: <span :class="{ labelerr: error }" v-if="error">{{ errorMsg }}</span>
    </div>
    <input
    v-if="!Mask.length && !Money"
    :class="{ err: error, placered: placered }"
    :type="type"
    :style="input"
    :value="value"
    @input="$emit('update:modelValue', $event.target.value)"
    :disabled="disabled"
    :placeholder="placeholder"
    >
    <input
    v-if="Mask.length > 0 && !Money"
    :class="{ err: error, placered: placered }"
    :type="type"
    :style="input"
    :value="value"
    @input="$emit('update:modelValue', $event.target.value)"
    :disabled="disabled"
    v-mask="Mask"
    :placeholder="placeholder"
    >
    <input
    :class="{ err: error, placered: placered }"
    v-if="Money"
    :type="type"
    :style="input"
    :value="value"
    @input="$emit('update:modelValue', $event.target.value)"
    :disabled="disabled"
    v-money="money"
    :placeholder="placeholder"
    >
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
export default {
  name: 'InputReg',
  emits: ['update:modelValue'],
  directives: { mask: mask, money: VMoney },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    placered: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    cont: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: Object,
      default: () => ({})
    },
    input: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: 'Label'
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    Mask: {
      type: Array,
      default: () => ([])
    },
    Money: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.label {
  font-size: 12px;
  margin-bottom: 5px;
}

input:focus {
  outline: none;
}

input {
  border: thin solid #CCCCCC;
  background-color: #FFFFFF;
}

.placered::placeholder {
  color: red
}

.labelerr {
  color: red
}

.err {
  border: thin solid red;
}

span {
  float: right;
  width: 40%;
  margin-right: 2%;
  text-align: right;
}
</style>
